const Rakamlar = resolve => {
    require.ensure(['../views/apps/rakam/Rakamlar'], () => {
        resolve(require('../views/apps/rakam/Rakamlar'))
    })
};

const RakamlarIslem = resolve => {
    require.ensure(['../views/apps/rakam/RakamlarIslem'], () => {
        resolve(require('../views/apps/rakam/RakamlarIslem'))
    })
};

import Vue from 'vue'
Vue.component('Rakamlar', RakamlarIslem);

import layouts from '../layout'

export default {
    path: '/rakam',
    name: 'rakam',
    component: Rakamlar,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'islem',
            name: 'rakamislem',
            component: RakamlarIslem,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
